export default __webpack_public_path__ + "static/media/undraw_wip.6ee04a01.svg";